import React, { useState } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import PostCard from "./post-card"
import Text from "aldoo-ra/Text"
import SearchAndCategories from "./search-and-categories"

const BlogPostGallery = ({
  currentPage,
  setTotalPages,
}) => {
  const [searchQuery, setSearchQuery] = useState("")
  const [searchCategory, setSearchCategory] = useState("")
  const [searchResultCount, setSearchResultCount] = useState(0)

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const clearSearch = () => {
    setSearchQuery("")
    setSearchCategory("")
  }

  const getStatusMessage = () => {
    if (searchCategory && searchQuery) {
      return `Found ${searchResultCount} post${
        searchResultCount !== 1 ? "s" : ""
      } in ${searchCategory.title} containing "${searchQuery}"`
    } else if (searchCategory) {
      return `Found ${searchResultCount} post${
        searchResultCount !== 1 ? "s" : ""
      } in ${searchCategory.title}`
    } else if (searchQuery) {
      return `Found ${searchResultCount} post${
        searchResultCount !== 1 ? "s" : ""
      } containing "${searchQuery}"`
    }
    return ""
  }

  return (
    <div className="w-full xl:max-w-w1_xl 2xl:max-w-w1_2xl flex flex-col items-center lg:items-start pt-5 md:pt-0 px-4 md:px-8 lg:px-px1_l xl:px-px1_xl mx-auto">
      <div className="w-full md:max-w-[900px] lg:max-w-full flex flex-col items-center gap-10 md:-mt-16 pt-28 md:pt-44">
        <Text
          id="blog_home_list_title"
          component="h1"
          variant="h1"
          className="text-text text-center mb-4 md:mb-0"
        />

        <SearchAndCategories
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          searchCategory={searchCategory}
          setSearchCategory={setSearchCategory}
          getStatusMessage={getStatusMessage}
          clearSearch={clearSearch}
          handleSearchChange={handleSearchChange}
        />
      </div>

      {/* Blog Post Grid */}
      <div className="min-h-[60vh] w-full max-w-[450px] md:max-w-[900px] lg:max-w-w1_l xl:max-w-w1_xl 2xl:max-w-w1_2xl grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 auto-rows-min md:gap-x-4 xl:gap-x-3 2xl:gap-x-6 gap-y-6 md:gap-y-4 xl:gap-y-3 2xl:gap-y-6 mx-auto mt-4 md:mt-[74px] lg:mt-[46px]">
        <CMSRender
          contentType="BlogPost"
          sort={{ "content.publish_date": -1, _id: -1 }}
          page={currentPage}
          itemsPerPage={12}
          match={{
            "content.status": "published",
            ...(searchCategory && {
              "content.category._id": searchCategory._id,
            }),
            ...(searchQuery && {
              "content.title": {
                $regex: searchQuery,
                $options: "i",
              },
            }),
          }}
          onData={({ data, totalPages }) => {
            setTotalPages(totalPages)
            setSearchResultCount(data.length)
          }}
          renderItem={(post, id) => <PostCard key={id} post={post} />}
        />
      </div>
    </div>
  )
}

export default BlogPostGallery
